export default __webpack_public_path__ + "static/dresscode-6ec793156caede7098bcf6de5c4c5a15.jpg";